// src/components/fraud/BlacklistSummaryCards.js
// Top summary cards — identical StatCard pattern as FraudSummaryCards.

import React from 'react';
import { Container, Row } from 'react-bootstrap';

const buildCards = (stats) => [
  {
    id: 'bl-total',
    title: 'Total Blacklisted',
    subtitle: 'All entries',
    value: stats.total,
    icon: '🚫',
    accent: '#EF4444',
    accentBg: 'rgba(239,68,68,0.10)',
  },
  {
    id: 'bl-active',
    title: 'Active Entries',
    subtitle: 'Currently blocking',
    value: stats.active,
    icon: '🔴',
    accent: '#EF4444',
    accentBg: 'rgba(239,68,68,0.10)',
  },
  {
    id: 'bl-disabled',
    title: 'Disabled Entries',
    subtitle: 'Not enforced',
    value: stats.disabled,
    icon: '⭕',
    accent: '#A6A3B8',
    accentBg: 'rgba(166,163,184,0.10)',
  },
  {
    id: 'bl-today',
    title: "Today's Additions",
    subtitle: 'Added today',
    value: stats.today,
    icon: '📅',
    accent: '#D9FF1F',
    accentBg: 'rgba(217,255,31,0.08)',
  },
];

// ─── Identical to FraudSummaryCards StatCard ─────────────────────────────────
const StatCard = ({ card, loading }) => (
  <div
    id={`bl-card-${card.id}`}
    className="theme-card rounded-3 px-4 py-3 h-100"
    style={{ minHeight: 100, position: 'relative', overflow: 'hidden' }}
  >
    <div
      style={{
        position: 'absolute', top: 0, left: 0,
        width: '3px', height: '100%',
        background: card.accent, borderRadius: '4px 0 0 4px',
      }}
    />
    <div
      style={{
        position: 'absolute', top: 16, right: 16,
        width: 40, height: 40, borderRadius: '50%',
        background: card.accentBg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 18,
      }}
    >
      {card.icon}
    </div>
    <small
      className="body-text-three card-title-label d-block"
      style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 2 }}
    >
      {card.title}
    </small>
    <small style={{ fontSize: 10, color: 'var(--text-secondary)', opacity: 0.7 }}>
      {card.subtitle}
    </small>
    {loading ? (
      <div className="fraud-skeleton mt-2" style={{ width: '55%', height: 28, borderRadius: 6 }} />
    ) : (
      <h5
        className="text-h2 mt-2 mb-0 card-value"
        style={{ color: card.accent, fontSize: 26, fontWeight: 700, lineHeight: 1.2 }}
      >
        {card.value !== null && card.value !== undefined ? card.value : (
          <span style={{ color: 'var(--text-secondary)', fontSize: 14, fontWeight: 400 }}>—</span>
        )}
      </h5>
    )}
  </div>
);

const BlacklistSummaryCards = ({ stats, loading }) => {
  const cards = buildCards(stats);
  return (
    <section className="py-4 nav-body-bg" style={{ marginTop: '70px' }}>
      <Container fluid className="px-4">
        <Row className="g-3">
          {cards.map((card) => (
            <div key={card.id} className="col-12 col-sm-6 col-xl-3">
              <StatCard card={card} loading={loading} />
            </div>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BlacklistSummaryCards;
